var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54447 1V3.21181M5.54447 8.89931V11.1111M10.7484 1H4.24512C1.75438 1 1.05853 1.58139 1 3.84375C2.25513 3.84375 3.26963 4.8359 3.26963 6.05556C3.26963 7.27521 2.25513 8.26104 1 8.26736C1.05853 10.5297 1.75438 11.1111 4.24512 11.1111H10.7484C13.3497 11.1111 14 10.4792 14 7.95139V4.15972C14 1.63194 13.3497 1 10.7484 1Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50343 4.28771L9.9139 5.11526C9.95362 5.1947 10.0331 5.25429 10.1191 5.26753L11.0327 5.39994C11.2578 5.43304 11.3505 5.71109 11.185 5.86998L10.523 6.51216C10.4568 6.57174 10.4303 6.66443 10.4435 6.75711L10.6024 7.6641C10.6421 7.88919 10.4038 8.06132 10.2052 7.9554L9.39089 7.52507C9.35067 7.50547 9.30652 7.49528 9.26179 7.49528C9.21705 7.49528 9.1729 7.50547 9.13269 7.52507L8.31839 7.9554C8.11315 8.06132 7.88144 7.88919 7.92116 7.6641L8.08005 6.75711C8.08743 6.7129 8.08406 6.66757 8.07024 6.62493C8.05641 6.5823 8.03253 6.54362 8.00061 6.51216L7.34519 5.86998C7.30832 5.83415 7.28221 5.7887 7.26982 5.7388C7.25744 5.68889 7.25928 5.63651 7.27512 5.5876C7.29097 5.53868 7.32019 5.49518 7.35949 5.46201C7.39878 5.42884 7.44658 5.40734 7.49746 5.39994L8.41107 5.26753C8.50376 5.25429 8.57658 5.20132 8.6163 5.11526L9.02015 4.28771C9.11283 4.08248 9.40413 4.08248 9.50343 4.28771Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconMenu);
export default __webpack_public_path__ + "static/media/common-icon-menu.b1c6d631632260027d5ccd566b507178.svg";
export { ForwardRef as ReactComponent };